module.exports = __webpack_public_path__ + "static/media/C_8.417f3fc5.png";